export const Share = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="23" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
<circle cx="23" cy="25" r="4" stroke="currentColor" stroke-width="2"/>
<circle cx="7" cy="16" r="4" stroke="currentColor" stroke-width="2"/>
<path d="M10.4857 14.3155L19.3722 8.72803" stroke="currentColor" stroke-width="2"/>
<path d="M10.4857 17.6519L19.3722 23.2394" stroke="currentColor" stroke-width="2"/>
</svg>`;
